import { render, staticRenderFns } from "./display-field-entity-ids.vue?vue&type=template&id=22311862&scoped=true&"
import script from "./display-field-entity-ids.ts?vue&type=script&lang=ts&"
export * from "./display-field-entity-ids.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-entity-ids.scss?vue&type=style&index=0&id=22311862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22311862",
  null
  
)

export default component.exports